import { Loading } from '@winnin/winnin_ui.components.loading'
import { Title } from '@winnin/winnin_ui.components.title'

import { BaseSkeleton } from 'components/BaseSkeleton'
import LoadingErrorWrapper from 'components/LoadingErrorWrapper'
import SkeletonTable from 'components/SkeletonTable'
import { TerritoriesTable } from 'components/TerritoriesTable'
import DateRangeFilter from 'components/TerritoryChipsFilter/components/DateRangeFilter'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import './global-topics-table.styles.scss'
import type { IGlobalTopicsTable } from '../common/global-topic.types'

export const GlobalTopicsTableView = ({
  data,
  error,
  handleSetOrder,
  hasMore,
  isFetchingMore,
  isLoading,
  order,
  refetch,
  sentryRef,
  totalCount,
  isZaiReportColumnVisible,
  isRelevanceRetryVisible,
}: IGlobalTopicsTable) => {
  const t = useTranslate()
  return (
    <div className="GlobalTopicsTable">
      <div className="GlobalTopicsTable-titleRow">
        <div className="countSection">
          {isLoading ? (
            <BaseSkeleton height={12} borderRadius={20} width={150} />
          ) : (
            <Title tag="h3">
              {t({
                ...TOLGEE_GLOBALS.results,
                parameters: {
                  results: totalCount ?? 0,
                },
              })}
            </Title>
          )}
        </div>
        <DateRangeFilter />
      </div>
      <div className="GlobalTopicsTable-tableSection">
        <LoadingErrorWrapper
          error={error}
          loading={isLoading}
          refetch={refetch}
          isEmpty={!data?.length}
          skeletonComponent={SkeletonTable}
        >
          <>
            <TerritoriesTable
              territories={data}
              handleSort={handleSetOrder}
              sortOrder={order?.order ?? ''}
              sortField={order?.field ?? ''}
              allowSortByVideos
              isZaiReportColumnVisible={isZaiReportColumnVisible}
              isRelevanceRetryVisible={isRelevanceRetryVisible}
            />
            {(isFetchingMore || hasMore) && (
              <div ref={sentryRef}>
                <Loading />
              </div>
            )}
          </>
        </LoadingErrorWrapper>
      </div>
    </div>
  )
}
